(() => {
  const sizes = ['X-Small','Small','Medium','Large','X-Large','XX-Large','XXX-Large'];
  const colors = {'Floral White':'#f4f2e8','Off-white':'#eeeadd','Linen':'#d3c5b1','Peach':'#efbfaa','Sky Blue':'#a6c5d4','Prussian Blue':'#20445f','Black':'#202321','Purple':'#88768e','Green':'#4e674d'};
  function enhance(picker) {
    if (picker.querySelector('.afz-choice-groups')) return;
    const form = picker.querySelector('.variant-picker__form');
    if (!form || form.querySelectorAll('fieldset').length !== 1) return;
    const inputs = [...form.querySelectorAll('input[type=radio]')];
    if (inputs.length < 12) return;
    const entries = inputs.map(input => {
      const size = sizes.slice().sort((a,b)=>b.length-a.length).find(s=>input.value.endsWith(' '+s));
      return size ? {input,size,color:input.value.slice(0,-size.length).trim()} : null;
    });
    if (entries.some(e=>!e) || new Set(entries.map(e=>e.color)).size<2) return;
    const selected = entries.find(e=>e.input.checked) || entries[0];
    let currentColor=selected.color, currentSize=selected.size;
    const wrapper=document.createElement('div');wrapper.className='afz-choice-groups';
    const colorSet=[...new Set(entries.map(e=>e.color))];
    const sizeSet=sizes.filter(s=>entries.some(e=>e.size===s));
    function choose(color,size) {
      const target=entries.find(e=>e.color===color&&e.size===size&&e.input.dataset.optionAvailable!=='false');
      if (!target) return;
      currentColor=color;currentSize=size;paint();
      target.input.click();
    }
    const controls=[];
    function group(label,values,kind) {
      const fieldset=document.createElement('fieldset');
      const legend=document.createElement('legend');fieldset.append(legend);
      const options=document.createElement('div');options.className='afz-choice-options';fieldset.append(options);
      for(const value of values) {
        const button=document.createElement('button');button.type='button';
        if(kind==='color') {const swatch=document.createElement('span');swatch.className='afz-choice-swatch';swatch.style.backgroundColor=colors[value]||'#d7ddd5';swatch.setAttribute('aria-hidden','true');button.append(swatch);}
        button.append(document.createTextNode(kind==='size'?({'X-Small':'XS','Small':'S','Medium':'M','Large':'L','X-Large':'XL','XX-Large':'XXL','XXX-Large':'3XL'}[value]||value):value));
        button.setAttribute('aria-label',value);
        button.addEventListener('click',()=>{
          if(kind==='size'){choose(currentColor,value);}else{
            const match=entries.find(e=>e.color===value&&e.size===currentSize&&e.input.dataset.optionAvailable!=='false')||entries.find(e=>e.color===value&&e.input.dataset.optionAvailable!=='false');
            if(match) choose(value,match.size);
          }
        });
        options.append(button);controls.push({button,value,kind});
      }
      wrapper.append(fieldset);return legend;
    }
    const colorLegend=group('Color',colorSet,'color');
    const sizeLegend=group('Size',sizeSet,'size');
    function paint(){
      colorLegend.textContent='Color: '+currentColor;sizeLegend.textContent='Size: '+currentSize;
      controls.forEach(({button,value,kind})=>{
        button.setAttribute('aria-pressed',String(value===(kind==='color'?currentColor:currentSize)));
        button.disabled=kind==='size'?!entries.some(e=>e.color===currentColor&&e.size===value&&e.input.dataset.optionAvailable!=='false'):!entries.some(e=>e.color===value&&e.input.dataset.optionAvailable!=='false');
      });
    }
    paint();form.before(wrapper);form.classList.add('afz-native-hidden');
  }
  let scheduled=false;
  function run(){scheduled=false;document.querySelectorAll('.afz-template-product variant-picker').forEach(enhance);}
  const observer=new MutationObserver(mutations=>{
    if(scheduled||!mutations.some(m=>[...m.addedNodes].some(n=>n.nodeType===1&&!n.closest?.('.afz-choice-groups'))))return;
    scheduled=true;requestAnimationFrame(run);
  });
  observer.observe(document.body,{subtree:true,childList:true});
  customElements.whenDefined('variant-picker').then(run);
})();

/* Shared responsive disclosures and editorial navigation. */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = window.matchMedia('(min-width: 750px)');
  function disclosures(){document.querySelectorAll('[data-afz-desktop-open]').forEach(el=>el.open=desktop.matches);}
  disclosures(); desktop.addEventListener('change',disclosures);
  const rail=document.getElementById('afz-moments-rail');
  if(!rail)return;
  const slides=[...rail.children];
  const buttons=[...document.querySelectorAll('[data-afz-rail-step]')];
  const count=document.querySelector('[data-afz-rail-count]');
  function current(){return slides.reduce((best,slide,i)=>Math.abs(slide.offsetLeft-rail.scrollLeft-parseFloat(getComputedStyle(rail).paddingLeft))<Math.abs(slides[best].offsetLeft-rail.scrollLeft-parseFloat(getComputedStyle(rail).paddingLeft))?i:best,0);}
  function update(){const n=current();if(count)count.textContent=`${n+1} / ${slides.length}`;buttons.forEach(b=>b.disabled=Number(b.dataset.afzRailStep)<0?n===0:rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-4);}
  function move(step){const i=Math.min(slides.length-1,Math.max(0,current()+step));rail.scrollTo({left:slides[i].offsetLeft-parseFloat(getComputedStyle(rail).paddingLeft),behavior:reduced.matches?'instant':'smooth'});}
  buttons.forEach(b=>b.addEventListener('click',()=>move(Number(b.dataset.afzRailStep))));
  rail.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}});
  let frame;rail.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(update);},{passive:true});
  update();
})();
